<template>
  <div style="float: right;">
    <span style="color: #0BB78E; cursor: pointer;" @click="showDetail">店铺提报情况{{reportNum}}</span>
    <!-- dialog  -->
    <v-dialog
      v-model="visible"
      :config="dialogConfig">
      <div slot="content">
        <el-table :data="tableData">
          <el-table-column label="平台名称" prop="platformName"></el-table-column>
          <el-table-column label="店铺名称" width="200px" prop="storeName">
            <template slot-scope="scope">
              <remark :content="scope.row.storeName"></remark>
            </template>
          </el-table-column>
          <el-table-column label="店铺简称" prop="shortName">
            <template slot-scope="scope">
              <remark :content="scope.row.shortName"></remark>
            </template>
          </el-table-column>
          <el-table-column label="是否提报" prop="submission">
            <template slot-scope="scope">
              <span v-if="scope.row.submission != 0">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="提报人" prop="submissionBy">
            <template slot-scope="scope">
              <remark :content="scope.row.submissionBy"></remark>
            </template>
          </el-table-column>
          <el-table-column label="提报时间" width="150px" prop="submissionDate">
            <template slot-scope="scope">
              <remark :content="scope.row.submissionDate"></remark>
            </template>
          </el-table-column>
        </el-table>
        <!-- pagination -->
        <div style="text-align: right; margin-top: 10px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  mixins: [mixin],
  data() {
    return {
      visible: false,
      dialogConfig: {
        title: '店铺提报情况',
        showButton: false,
        width: '60%'
      },
      tableData: [],
      paginationOpt: {
        pageSizes: [10, 30],
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      reportNum: ''
    }
  },
  computed: {
    // ...mapGetters({
    //   // 提报店铺数量
    //   reportNum: 'reportNum'
    // })
  },
  mounted() {
    this.importTotal()
  },
  methods: {
    showDetail() {
      this.visible = true;
      this.init();
    },
    async init() {
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          planTime: moment(new Date()).subtract(-1,'months').format('YYYY-MM')
        }
      };
      let res = await this.$q.dataImport.importList({data});
      if(res.success && res.data && res.data.records.length) {
        this.tableData = res.data.records;
        this.paginationOpt.total = res.data.total;
      }else{
        this.tableData = res.data.records;
        this.paginationOpt.total = 0;
      }
    },
   async importTotal() {
      const params = {
        // params: {
          planTime: moment(new Date()).subtract(-1,'months').format('YYYY-MM')
        // }
      };
      let res = await this.$q.dataImport.importTotal({params});
      if(res.success && res.code == 200) {
        this.reportNum = `${res.data.importNum}/${res.data.total}`
      }
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    }
  }
}
</script>

<style>

</style>